import { Table } from '../../../design-system';
import '../../styles/TallyPanel.css';

// What Tally actually replied to the last scan.
//
// ⚠️ THIS EXISTS BECAUSE EVERY DIAGNOSIS HERE HAS BEEN A GUESS. Whether
// `ISINITIALIZE` works on a given build, whether a folder lists anything,
// whether the reply parsed — all of it was reasoned about rather than observed,
// and the failure always looks the same from outside: a short list that reads
// like a correct answer. One company out of a hundred and twenty two is
// indistinguishable from a firm that has one company, unless somebody can see
// what came back.
//
// ⚠️ THE RAW REPLY IS KEPT ONLY WHERE IT ANSWERS SOMETHING — a folder that
// returned companies needs no explaining. An empty one is the whole question:
// did Tally refuse, answer an empty envelope, or send something we failed to
// read? Those are three different faults with three different fixes.

function TallyScanDiagnostics({ diagnostics = [] }) {
  if (!diagnostics.length) return null;

  const total = diagnostics.reduce((n, d) => n + (d.companies || 0), 0);
  const empty = diagnostics.filter((d) => d.ok && !d.companies);
  const broken = diagnostics.filter((d) => !d.ok);

  return (
    <details className="tally-diag">
      <summary>
        What Tally replied — {diagnostics.length} folder(s), {total} company(ies)
        {empty.length ? `, ${empty.length} empty` : ''}
        {broken.length ? `, ${broken.length} failed` : ''}
      </summary>

      <p className="tally-muted">
        Send this to whoever maintains HRMS if the list below is missing companies
        you can see in Tally.
      </p>

      <Table
        columns={[
          {
            key: 'folder',
            header: 'Folder asked about',
            render: (d) => <span className="tally-mono">{d.folder || '—'}</span>,
          },
          {
            key: 'req',
            header: 'Request',
            render: (d) => <span className="tally-muted">{d.request || 'data directory'}</span>,
          },
          {
            key: 'result',
            header: 'Companies',
            render: (d) => {
              if (!d.ok) return <span className="tally-error">failed</span>;
              if (!d.companies) return <span className="tally-warn">none</span>;
              return `${d.companies}`;
            },
          },
          {
            key: 'names',
            header: 'First few',
            render: (d) => (d.names?.length
              ? <span className="tally-muted">{d.names.join(', ')}</span>
              : '—'),
          },
          {
            key: 'bytes',
            header: 'Reply size',
            render: (d) => (d.bytes != null ? `${d.bytes} B` : '—'),
          },
        ]}
        data={diagnostics.map((d, i) => ({ ...d, _k: `${d.folder}-${i}` }))}
        keyField="_k"
      />

      {/* The bit that actually settles an argument. Shown verbatim, not
          summarised — a summary of a reply we misread is another guess. */}
      {diagnostics.filter((d) => d.sample).map((d, i) => (
        <div key={`${d.folder}-sample-${i}`} className="tally-diag-sample">
          <strong>{d.folder || 'Tally'}</strong>
          {d.error ? <span className="tally-error"> — {d.error}</span> : null}
          <pre className="tally-evidence">{d.sample}</pre>
        </div>
      ))}
    </details>
  );
}

export default TallyScanDiagnostics;
